import PropTypes from 'prop-types'

const ExternalLink = ({ className, href, title, children }) => (
  <a
    className={className}
    href={href}
    title={title}
    target="_blank"
    rel="noopener noreferrer"
  >
    {children}
  </a>
)

ExternalLink.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
}

ExternalLink.defaultProps = {
  className: '',
}

export default ExternalLink
